import { render, staticRenderFns } from "./SectionHead.vue?vue&type=template&id=fc7da7d4&scoped=true&"
import script from "./SectionHead.vue?vue&type=script&lang=js&"
export * from "./SectionHead.vue?vue&type=script&lang=js&"
import style0 from "./SectionHead.vue?vue&type=style&index=0&id=fc7da7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7da7d4",
  null
  
)

component.options.__file = "SectionHead.vue"
export default component.exports